<div class="loading_icon mb-6"></div>
<h1>Przetwarzanie płatności</h1>
<p>Twoja płatność jest właśnie przetwarzana. Powinno nastąpić przekierowanie.</p>
